import { AnalyticsServiceProvider } from '../analytics-service/analytics-service';
import { App, IonicApp, Nav, Platform } from 'ionic-angular';
import { AuthenticationServiceProvider } from '../authentication-service/authentication-service';
import { Injectable } from '@angular/core';
import { PlayerServiceProvider } from '../player-service/player-service';
import { TenantService } from '../tenant-service/tenant.service';
import { AlertServiceProvider } from '../alert-service/alert-service';
import { filter } from 'rxjs/operators';

@Injectable()
export class LifeCycleServiceProvider {
  private ionicApp: IonicApp;
  private nav: Nav;

  constructor(
    private analyticsService: AnalyticsServiceProvider,
    private app: App,
    private authenticationService: AuthenticationServiceProvider,
    private platform: Platform,
    private playerService: PlayerServiceProvider,
    private tenantService: TenantService,
    private alertService: AlertServiceProvider,
  ) {}

  public initialize(ionicApp: IonicApp, nav: Nav): void {
    this.ionicApp = ionicApp;
    this.nav = nav;
    this.handleCodeflow().then(() => this.initializeEventListeners());
  }

  private handleCodeflow(): Promise<void> {
    const searchParams = new URLSearchParams(window.location.search);

    if (searchParams.get('code') == null) {
      return Promise.resolve();
    }

    return this.tenantService
      .setTenant(searchParams.get('tenant'))
      .then(() => window.history.replaceState('remove-code-search-parms', '', '/'))
      .then(() => this.authenticationService.exchangeCodeForToken(searchParams.get('code')))
      .catch(() => this.alertService.showCodeFlowLoginError());
  }

  private initializeEventListeners(): void {
    this.platform.registerBackButtonAction(() => this.handlePressedBackButton());
    this.platform.pause.subscribe(() => this.onPause());
    this.platform.ready().then(() => this.onDeviceReady());

    this.authenticationService
      .getState()
      .pipe(filter((auth) => !auth))
      .subscribe(() => this.onAuthFailed());
  }

  private handlePressedBackButton() {
    const thereIsPreviousScreen = this.nav.length() > 1;
    const modal = this.ionicApp._modalPortal.getActive();
    const toast = this.ionicApp._toastPortal.getActive();
    const overlay = this.ionicApp._overlayPortal.getActive();
    const activeComponentId = this.nav.getActive().id;

    if (thereIsPreviousScreen) {
      this.nav.pop();
    } else if (modal || toast || overlay) {
      const toDismiss = modal || toast || overlay;
      toDismiss.dismiss();
    } else if (activeComponentId === 'MenuPage' || activeComponentId === 'LoginPage') {
      this.alertService.showConfirmApplicationClosing();
    } else {
      this.nav.setRoot('MenuPage', { root: 0 }, { animate: true });
    }
  }

  private onPause(): void {
    this.playerService
      .getPlayer()
      .then((player) => this.analyticsService.sendScreenData(player))
      .catch(() => this.analyticsService.sendScreenData('getPlayerError'));
  }

  private onDeviceReady(): void {
    this.authenticationService
      .validateTokens()
      .then(() => this.app.getRootNav().setRoot('LoadingPage', {}, { animate: true, direction: 'forward' }))
      .catch(() => this.app.getActiveNavs()[0].setRoot('LoginPage'))
      .then(() => this.analyticsService.sendAnalytics('Start'));
  }

  private onAuthFailed(): void {
    this.app.getActiveNavs()[0].setRoot('LoginPage');
  }
}



// WEBPACK FOOTER //
// ./src/modules/core/services/life-cycle-service/life-cycle-service.ts